export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}


// 验证手机
export function validatePhone(rule, value, callback) {
  const reg = /^[1][3-9][0-9]{9}$/;
  if (value == '' || value == undefined || value == null) {
    callback(new Error('请输入手机号码'));
  } else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的电话号码'));
    } else {
      callback();
    }
  }
}

// 验证联系姓名
export function validateFullName(rule, value, callback) {
  if (value == '' || value == undefined || value == null) {
    callback(new Error('请输入联系人姓名'));
  } else {
    if (value.length > 20) {
      callback(new Error('联系人姓名最多20位字符'));
    } else {
      callback();
    }
  }
}

// 验证需求
export function validateDesc(rule, value, callback) {
  if (value == '' || value == undefined || value == null) {
    callback(new Error('请输入您的需求'));
  } else {
    if (value.length > 300) {
      callback(new Error('需求描述最多300个字符'));
    } else {
      callback();
    }
  }
}

// 验证反馈
export function validateFeedbackDesc(rule, value, callback) {
  if (value == '' || value == undefined || value == null) {
    callback(new Error('请输入您的反馈'));
  } else {
    if (value.length > 300) {
      callback(new Error('反馈描述最多300个字符'));
    } else {
      callback();
    }
  }
}

// 验证需求
export function validateCompany(rule, value, callback) {
  if (value == '' || value == undefined || value == null) {
    callback(new Error('请输入您的单位名称'));
  } else {
    if (value.length > 300) {
      callback(new Error('单位名称最多30个字符'));
    } else {
      callback();
    }
  }
}

// 验证邮箱
export function validateEMail(rule, value, callback) {
  const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
  if (value == '' || value == undefined || value == null) {
    callback(new Error('请输入邮箱'));
  } else {
    if (!reg.test(value)) {
      callback(new Error('请输入正确的邮箱'));
    } else {
      callback();
    }
  }
}

// 验证密码
export const validatePsdReg = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入密码'));
  }
  if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){8,20}$/.test(value)) {
    callback(new Error('请输入8-20位英文字母、数字或者符号（除空格），且至少包含大小写字母/符号/数字中的两种'));
  } else {
    callback();
  }
};

// 验证账号
export const validateAccount = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入账号'));
  }
  if (!(/^[a-zA-Z0-9_]{5,50}$/.test(value))) {
    callback(new Error('账号仅支持字母,数字,下划线,最少5位,最多50位'));
  } else {
    callback();
  }
};

export function validNumber(str) {
  const reg = /^([1-9]\d*|[0]{1,1})$/;
  return reg.test(str);
}